import { render, staticRenderFns } from "./exchange_order_detail.vue?vue&type=template&id=5f4ddc40&scoped=true"
import script from "./exchange_order_detail.vue?vue&type=script&lang=ts"
export * from "./exchange_order_detail.vue?vue&type=script&lang=ts"
import style0 from "./exchange_order_detail.vue?vue&type=style&index=0&id=5f4ddc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ddc40",
  null
  
)

export default component.exports